import request from '@/utils/request'

export function getValidApplication(type) {
  return request({
    requestForm: true,
    url: '/teacher/application/getValidApplication',
    method: 'post',
    data: {type}
  })
}

export async function submit(data) {
  return request({
    requestForm: false,
    url: '/teacher/application/submit',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/application.js